import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'

interface MultipleAnwsersProps {
  languageIndex: number
}

const MultipleAnwsers: React.FC<MultipleAnwsersProps> = (props) => {
  const { languageIndex } = props
  const { t } = useTranslation()
  const { control } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchPlaceholder = useWatch({ control, name: `languages[${languageIndex}].placeholder` })
  const watchNumberOfFields = useWatch({ control, name: 'value' })
  const watchReq = useWatch({ control, name: 'required' })

  function renderPreview() {
    const arr = Array.from({ length: watchNumberOfFields }, (_, index) => index)
    return <QuestionPreview>
      <>
        <Form.Field label={t('Possible answer(s)')} />
        <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
        {arr?.map((anwser) => {
          return <Form.TextArea
            key={anwser}
            placeholder={watchPlaceholder}
          />
        })}
      </>
    </QuestionPreview>
  }

  return <>
    <FormFields.TextArea
      control={control}
      label={t('Type in your question')}
      placeholder={t('Type in your question')}
      name={`languages[${languageIndex}].question`}
      rules={{
        required: {
          value: true,
          message: t('Please enter question')
        }
      }}
    />
    <FormFields.Input
      control={control}
      label={t('Placeholder')}
      placeholder={t('Placeholder')}
      name={`languages[${languageIndex}].placeholder`}
    />
    {renderPreview()}
  </>
}
export default MultipleAnwsers